import { useState, useEffect } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { getSubjects } from "../../../ApiService/ApiService";
import SubjectTable from "./SubjectTable";
import AddSubject from "./AddSubject";
import { Add } from "@mui/icons-material";

function SubjectSection() {
  const [subjects, setSubjects] = useState({});
  const [showAddSubject, setShowAddSubject] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      setLoading(true);
      const response = await getSubjects();
      setSubjects(response?.data);
    } catch (err) {
      console.error("Error fetching subjects:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderMainContent = () => {
    if (showAddSubject) {
      return (
        <AddSubject
          fetchSubjects={fetchSubjects}
          setShowAddSubject={setShowAddSubject}
        />
      );
    } else {
      return <SubjectTable subjects={subjects} fetchSubjects={fetchSubjects} />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddSubject ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{ color: "black", fontWeight: 600, fontSize: 22 }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Subjects
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddSubject(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Subject
        </Button>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>{renderMainContent()}</>
      )}
    </>
  );
}

export default SubjectSection;
